module.exports = __webpack_public_path__ + "img/jo1.dd25877f.png";